export const BRAND = {
  name: "TarotGuidanceByIshitaDhar",
  short: "Ishita Dhar",
  instagram: "https://www.instagram.com/tarotguidance_by_ishitadhar/?hl=en",
  instagramHandle: "@tarotguidance_by_ishitadhar",
  whatsapp: "https://wa.me/918826110104",
  whatsappLabel: "Message on WhatsApp",
  bookingForm: "https://forms.gle/BcJfiiydr6a4yZZx9",
};
